/**
 * Upload API base URL — bypasses Cloudflare for large file uploads (demos).
 * Uses upload.stratsync.pro subdomain (DNS-only, no Cloudflare proxy)
 * to avoid Cloudflare's 100MB upload limit and 100s request timeout.
 *
 * Falls back to the standard API URL for local development.
 */
const API = import.meta.env.VITE_API_URL || 'http://localhost:3001';

export const UPLOAD_API = import.meta.env.VITE_UPLOAD_API_URL || API;
